import { useCallback, useEffect, useState } from 'react';

const usePagination = ({ rowsPerPageOptions = [10, 20, 30], defaultRowsPerPage = 10, initialPage = 0 }) => {
  const [allData, setAllData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [pageNumber, setPageNumber] = useState(initialPage);

  const updateRow = (paginatedIndex, rowData) => {
    const allDataIndex = pageNumber * rowsPerPage + paginatedIndex;
    setAllData((prevData) => [...prevData.slice(0, allDataIndex), rowData, ...prevData.slice(allDataIndex + 1)]);
  };

  const setData = useCallback((data) => {
    setAllData(data);
    setPageNumber(0);
  }, []);

  useEffect(() => {
    setPageNumber(0);
  }, [rowsPerPage]);

  return {
    rowsPerPageOptions,
    rowsPerPage,
    pageNumber,
    allData,
    data: allData ? allData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage) : null,
    dataCount: allData ? allData.length : 0,
    setPageNumber,
    setRowsPerPage,
    updateRow,
    setData,
  };
};

export default usePagination;
